/**
 * @flow weak
 */


// Consts
export const TOGGLE_CANCEL_ORDER_MODAL = 'TOGGLE_CANCEL_ORDER_MODAL';
export const TOGGLE_REFUND_MODAL = 'TOGGLE_REFUND_MODAL';
export const TOGGLE_CHANGE_DATE_MODAL = 'TOGGLE_CHANGE_DATE_MODAL';
export const TOGGLE_TICKET_TRANSFER_MODAL = 'TOGGLE_TICKET_TRANSFER_MODAL';
export const TOGGLE_CANCEL_TICKET_TRANSFER_MODAL = 'TOGGLE_CANCEL_TICKET_TRANSFER_MODAL';
export const TOGGLE_TICKET_TRANSFER_DISABLED_MODAL = 'TOGGLE_TICKET_TRANSFER_DISABLED_MODAL';
export const TOGGLE_RESEND_TICKET_TRANSFER_MODAL = 'TOGGLE_RESEND_TICKET_TRANSFER_MODAL';
export const TOGGLE_EDIT_BUYER_INFO_MODAL = 'TOGGLE_EDIT_BUYER_INFO_MODAL';
export const TOGGLE_EDIT_GUEST_INFO_MODAL = 'TOGGLE_EDIT_GUEST_INFO_MODAL';
export const TOGGLE_PAY_INSTALLMENT_MODAL = 'TOGGLE_PAY_INSTALLMENT_MODAL';
export const TOGGLE_PAY_INSTALLMENTS_MODAL = 'TOGGLE_PAY_INSTALLMENTS_MODAL';
export const TOGGLE_GENERATE_INVOICE_CONFIRMATION_MODAL = 'TOGGLE_GENERATE_INVOICE_CONFIRMATION_MODAL';
export const TOGGLE_CANCEL_EVENT_DISCLOSURE_MODAL = 'TOGGLE_CANCEL_EVENT_DISCLOSURE_MODAL';
export const OPEN_TICKET_TRANSFER_MODAL = 'OPEN_TICKET_TRANSFER_MODAL';
export const CLOSE_TICKET_TRANSFER_MODAL = 'CLOSE_TICKET_TRANSFER_MODAL';

// Actions

//
// Pay installment
//
export const togglePayInstallment = (number) => {
  return {
    type: TOGGLE_PAY_INSTALLMENT_MODAL,
    payload: { number }
  };
};

//
// Pay remaining installments
//
export const togglePayRemainingInstallments = () => {
  return {
    type: TOGGLE_PAY_INSTALLMENTS_MODAL
  };
};

//
// Cancel Order modal
//
export const toggleCancelOrder = () => {
  return {
    type: TOGGLE_CANCEL_ORDER_MODAL
  };
};

//
// Request Refund modal
//
export const toggleRefund = () => {
  return {
    type: TOGGLE_REFUND_MODAL
  };
};

//
// Change Order Date modal
//
export const toggleChangeOrderDate = () => {
  return {
    type: TOGGLE_CHANGE_DATE_MODAL
  };
};


//
// Transfer Tickets and modal
//
export const toggleTransferTicket = () => {
  return {
    type: TOGGLE_TICKET_TRANSFER_MODAL
  };
};

export const openTransferTicket = () => {
  return {
    type: OPEN_TICKET_TRANSFER_MODAL
  };
};

export const closeTransferTicket = () => {
  return {
    type: CLOSE_TICKET_TRANSFER_MODAL
  };
};

export const toggleCancelTransferTicket = () => {
  return {
    type: TOGGLE_CANCEL_TICKET_TRANSFER_MODAL
  };
};

export const toggleTransferTicketDisabled = () => {
  return {
    type: TOGGLE_TICKET_TRANSFER_DISABLED_MODAL
  };
};

export const toggleResendTransferTicket = () => {
  return {
    type: TOGGLE_RESEND_TICKET_TRANSFER_MODAL
  };
};

//
// Edit Guest Info modal
//
export const toggleEditGuestInfo = () => {
  return {
    type: TOGGLE_EDIT_GUEST_INFO_MODAL
  };
};

//
// Edit Buyer Info modal
//
export const toggleEditBuyerInfo = () => {
  return {
    type: TOGGLE_EDIT_BUYER_INFO_MODAL
  };
};

//
// Generate Invoice Confirmation
//
export const toggleGenerateInvoiceConfirmation = () => {
  return {
    type: TOGGLE_GENERATE_INVOICE_CONFIRMATION_MODAL
  };
};


export const toggleEventDisclosure = () => {
  return {
    type: TOGGLE_CANCEL_EVENT_DISCLOSURE_MODAL
  };
};



// WEBPACK FOOTER //
// ./src/modules/modal/actions.js